/**
 * Quotes API calls.
 */

import { api } from './client.js';

// ── public ──

export function listQuotes() {
  return api.get('/api/quotes');
}

export function getRandomQuote() {
  return api.get('/api/quotes/random', { skipAuth: true });
}

// ── admin ──

export function listAdminQuotes() {
  return api.get('/api/admin/quotes');
}

export function createQuote(payload) {
  return api.post('/api/admin/quotes', payload);
}

export function updateQuote(id, payload) {
  return api.patch(`/api/admin/quotes/${id}`, payload);
}

export function deleteQuote(id) {
  return api.del(`/api/admin/quotes/${id}`);
}
